import axios from "axios";
// eslint-disable-next-line no-unused-vars
import router from "../router";
// eslint-disable-next-line no-unused-vars
import { useAuthStore } from "@/store/auth";

// const url = "http://127.0.0.1:8000/vs";
const url = "https://tmsdemo.basmeemis.org/vs";

export const AxiosClient = axios.create({
  baseURL: url,
});
AxiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 409) {
      //   // Handle 404 error (Not Found)
      //   useAuthStore().logout();
      //   router.push({ name: "default" })
    }
    //  if (error.response.status === 401) {
    //   // Handle 401 error (Unauthorized)
    //   useAuthStore().logout()
    //   router.push({ name: 'login' })
    // } else if (error.response.status === 409) {
    //   // Handle 404 error (Not Found)
    //   router.push({ name: "default" });
    // } else if (error.response.status === 404) {
    //   // Handle 404 error (Not Found)
    //   // return router.push({ name: "not-found" });
    //   router.push({ name: "default" });
    // }

    return Promise.reject(error);
  }
);
